module.exports = __webpack_public_path__ + "img/attribute1.b248785a.png";